import * as React from "react";
import "./style.css";
import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    Button,
    Checkbox,
    Modal,
    TableCell,
    TableRow
} from "@mui/material";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs/AdapterDayjs.js";
import {DatePicker} from "@mui/x-date-pickers/DatePicker/DatePicker.js";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js";

import TextInput from "../../../components/elements/TextInput";
import dayjs from "dayjs";
import FacilityETLs from "./FacilityETLs";
import SubmitButton from "../../../components/elements/SubmitButton";
import {
    fetchCurrentQuotas,
    fetchFacilityETLs,
    setUpdatedFacility,
    updateFacility
} from "../../../redux/models/integrations/Action";
import {ABORTED} from "../../../redux/constants";

const Facility = ({loggedInUser, integrationAccount, integrationNamespace, facility, etls, manageQuotas, setManageQuotas}) => {
    const [formState, setFormState] = useState({
        is_active: facility.is_active,
        inception_date: facility.inception_date,
        email: facility.email,
    });
    const [errors, setErrors] = useState({
        email: "",
        is_active: "",
        inception_date: ""
    });
    const dispatch = useDispatch();

    return <><TableRow>
        <TableCell>{facility.name}</TableCell>
        <TableCell>{facility.license_number}</TableCell>
        <TableCell>{facility.license_type}</TableCell>
        <TableCell>
            <TextInput
                name={"email"}
                label={"Contact Email"}
                formState={formState}
                errors={errors}
                setErrors={setErrors}
                setFormState={setFormState}
                email={formState.email || facility.email}
                autoComplete={"off"}
            />
        </TableCell>
        <TableCell>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker label="Inception Date"
                    value={dayjs(formState.inception_date ||
                                facility.inception_date)}
                    onChange={(newDate) => {
                        setFormState(state => {
                            return {
                                ...state,
                                inception_date: dayjs(newDate).format("YYYY-MM-DD")
                            };
                        });
                    }}/>
            </LocalizationProvider>
        </TableCell>
        <TableCell>
            <Checkbox
                checked={formState.is_active}
                onChange={(e) => {
                    setFormState(state => {
                        return {
                            ...state,
                            is_active: e.target.checked
                        };
                    });
                }}/>
        </TableCell>
        <TableCell>
            <Button onClick={() => {
                setManageQuotas({...manageQuotas, [facility.id]: !manageQuotas[facility.id]});
            }}>Manage Quotas/Sync Data</Button>
        </TableCell>
        <TableCell>
            <SubmitButton onClick={() => {
                return dispatch(updateFacility(integrationNamespace, {...facility, ...formState})).then(updatedFacility => {
                    setUpdatedFacility(integrationNamespace, updatedFacility);
                });
            }}>
                Save
            </SubmitButton>
        </TableCell>
    </TableRow>
    </>;
};


export default Facility;